<template>
  <div>
    <el-form ref="form" :model="queryForm" label-width="90px">
      <!-- <div class="flex flex-spacebetween align-items"> -->
      <el-row>
        <el-col :span="spanCol">
          <el-form-item label="逻辑仓编码">
            <BjInput
              v-model="queryForm.stockWarehouseCode"
              placeholder="逻辑仓编码"
              clearable
            ></BjInput>
          </el-form-item>
        </el-col>
        <el-col :span="spanCol">
          <el-form-item label="逻辑仓名称">
            <BjInput
              v-model="queryForm.stockWarehouseName"
              placeholder="逻辑仓名称"
              clearable
            ></BjInput>
          </el-form-item>
        </el-col>
        <el-col :span="24 - spanCol * 2" style="display: flex; justify-content: flex-end;">
          <el-button type="cyan" icon="el-icon-search" class="m20" @click="onSearch"
            >{{ $t('queryText') }}</el-button
          >
          <el-button v-if="showResetBtn" @click="resetQueryForm">{{ $t('resetText') }}</el-button>
        </el-col>
      </el-row>
      <!-- </div> -->
    </el-form>
    <el-table
      :data="data"
      border
      stripe
      :header-cell-style="$rowStyle.DEFAULT"
      :row-style="rowStyleFun"
      :height="height"
      style="width: 100%"
    >
      <el-table-column label="选择" width="55" align="center">
        <template slot-scope="scope">
          <el-radio
            v-model="radio"
            :label="scope.row.stockNo"
            :disabled="!checkSelectable(scope.row)"
            @change.native="getCurrentRow(scope.row)"
          >
            {{ '' }}
          </el-radio>
        </template>
      </el-table-column>
      <el-table-column type="expand" label="查看可用库存" width="160px">
        <template slot-scope="props">
          <div style="padding: 10px;">
            <el-table :data="props.row.stockList" border :header-cell-style="$rowStyle.LIGHT_BLUE">
              <el-table-column prop="skuCode" label="SKU编码" align="center" width="160px">
              </el-table-column>
              <el-table-column prop="skuName" label="SKU名称" align="center"> </el-table-column>
              <el-table-column prop="number" label="可用数量" align="center"> </el-table-column>
            </el-table>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="stockNo" label="逻辑仓编码" align="center"> </el-table-column>
      <el-table-column prop="stockName" label="逻辑仓名称" align="center"> </el-table-column>
    </el-table>
    <BjDivider>
      指定发货仓
      <template #right>
        <BjInput v-model="selectedData.stockName" readonly placeholder="请选择逻辑仓" />
      </template>
    </BjDivider>
  </div>
</template>

<script>
import { stockApi } from '@/api';
const defaultForm = () => {
  return {
    stockWarehouseCode: '',
    stockWarehouseName: '',
  };
};
export default {
  name: 'BusinessOrderSourceAppointDeliveryParcelRight',
  props: {
    height: {
      type: [String, Number],
      default: '280px',
    },
    showResetBtn: {
      type: Boolean,
      default: false,
    },
    rowKeys: {
      type: String,
      default: 'logicId',
    },
    disabled: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      spanCol: 10,
      queryForm: defaultForm(),
      original: [], // 原始数据
      data: [],
      dialogVisible: false,
      radio: '',
      selectedData: {},
    };
  },
  methods: {
    getData(skuList) {
      stockApi
        .getOrderSourcingLogicWarehouse({ skuList })
        .then(res => {
          if (!res.failed) {
            this.original = this.$lodash.clone(res);
            this.data = res;
          }
        });
    },
    onSearch() {
      const { stockWarehouseCode, stockWarehouseName } = this.queryForm;
      const queryData = stockWarehouseCode + stockWarehouseName;
      this.data = this.original.filter(
        e =>
          (stockWarehouseCode ? e.stockNo : '') + (stockWarehouseName ? e.stockName : '') ===
          queryData,
      );
    },
    getCurrentRow(row) {
      this.selectedData = row;
    },
    reset() {
      this.queryForm = defaultForm();
      this.data = [];
      this.radio = '';
      this.selectedData = {};
    },
    resetQueryForm() {
      this.queryForm = defaultForm();
    },
    /** 设置禁止选中的条件 */
    checkSelectable(row, index) {
      return !this.disabled.includes(row[this.rowKeys]);
    },
    // 禁用的标颜色  #c0c4cc
    rowStyleFun({ row, rowIndex }) {
      const DISABLED_FLAG = !this.checkSelectable(row, rowIndex);
      const styleJson = {};
      if (DISABLED_FLAG) {
        styleJson.color = '#c0c4cc';
      }
      return styleJson;
    },
  },
};
</script>

<style></style>
